import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import axios from 'axios';

// I-31
export const useGetKarenoteTimeline = ({ hspId, patientNumber, searchStartDate, searchEndDate }) => {
  const { data, refetch, isFetching } = useQuery({
    queryKey: ['timeline', hspId, patientNumber, searchStartDate, searchEndDate],
    queryFn: () => {
      // return new Promise((resolve) => {
      //   setTimeout(() => {
      //     resolve({
      //       status: 200,
      //       data: {
      //         result: 0,
      //         privacyPolicyUrl: `https://dongsan.dsmc.or.kr:49870/content/06guide/01_01.php`,
      //         timeline: [
      //           {
      //             pactId: '1',
      //             pactType: 'I',
      //             pactStartDate: '2024-01-01',
      //             pactEndDate: '2024-12-31',
      //             departmentName: '신경외과(뇌신경센터)',
      //             doctorName: '김의사',
      //             diagnosisName: '주 진단명 (뇌종양 수술)',
      //             spcTestDescription: '검체검사 외 3건',
      //             imgTestDescription: '영상검사 외 3건',
      //             funcTestDescription: '기능검사 외 3건',
      //             patTestDescription: '병리검사 외 3건',
      //           },
      //           {
      //             pactId: '2',
      //             pactType: 'I',
      //             pactStartDate: '2025-01-01',
      //             pactEndDate: '2025-12-31',
      //             departmentName: '신경외과(뇌신경센터)',
      //             doctorName: '김의사',
      //             diagnosisName: '주 진단명 (뇌종양 수술)',
      //             spcTestDescription: '검체검사 외 3건',
      //             imgTestDescription: '영상검사 외 3건',
      //             funcTestDescription: '기능검사 외 3건',
      //             patTestDescription: '병리검사 외 3건',
      //           },
      //           {
      //             pactId: '2',
      //             pactType: 'S',
      //             pactStartDate: '2025-01-01',
      //             pactEndDate: '2025-12-31',
      //             departmentName: '신경외과(뇌신경센터)',
      //             doctorName: '김의사',
      //             diagnosisName: '주 진단명 (뇌종양 수술)',
      //             spcTestDescription: '검체검사 외 3건',
      //             imgTestDescription: '영상검사 외 3건',
      //             funcTestDescription: '기능검사 외 3건',
      //             patTestDescription: '병리검사 외 3건',
      //           },
      //           {
      //             pactId: '3',
      //             pactType: 'O',
      //             pactStartDate: '2025-01-01',
      //             pactEndDate: '2025-12-31',
      //             departmentName: '신경외과(뇌신경센터)',
      //             doctorName: '김의사',
      //             diagnosisName: '주 진단명 (뇌종양 수술)',
      //             spcTestDescription: '검체검사 외 3건',
      //             imgTestDescription: '영상검사 외 3건',
      //             funcTestDescription: '기능검사 외 3건',
      //             patTestDescription: '병리검사 외 3건',
      //           },
      //           {
      //             pactId: '4',
      //             pactType: 'E',
      //             pactStartDate: '2025-01-01',
      //             pactEndDate: '2025-12-31',
      //             departmentName: '신경외과(뇌신경센터)',
      //             doctorName: '김의사',
      //             diagnosisName: '주 진단명 (뇌종양 수술)',
      //             spcTestDescription: '검체검사 외 3건',
      //             imgTestDescription: '영상검사 외 3건',
      //             funcTestDescription: '기능검사 외 3건',
      //             patTestDescription: '병리검사 외 3건',
      //           },
      //           ...(searchStartDate?.slice(0, 4) !== '2024'
      //             ? [
      //                 {
      //                   pactId: '5',
      //                   pactType: 'I',
      //                   pactStartDate: '2024-01-01',
      //                   pactEndDate: '2024-12-31',
      //                   departmentName: '신경외과(뇌신경센터)',
      //                   doctorName: '김의사',
      //                   diagnosisName: '주 진단명 (뇌종양 수술)',
      //                   spcTestDescription: '검체검사 외 3건',
      //                   imgTestDescription: '영상검사 외 3건',
      //                   funcTestDescription: '기능검사 외 3건',
      //                   patTestDescription: '병리검사 외 3건',
      //                 },
      //                 {
      //                   pactId: '5',
      //                   pactType: 'I',
      //                   pactStartDate: '2024-01-01',
      //                   pactEndDate: '2024-12-31',
      //                   departmentName: '신경외과(뇌신경센터)',
      //                   doctorName: '김의사',
      //                   diagnosisName: '주 진단명 (뇌종양 수술)',
      //                   spcTestDescription: '검체검사 외 3건',
      //                   imgTestDescription: '영상검사 외 3건',
      //                   funcTestDescription: '기능검사 외 3건',
      //                   patTestDescription: '병리검사 외 3건',
      //                 },
      //                 {
      //                   pactId: '5',
      //                   pactType: 'I',
      //                   pactStartDate: '2024-01-01',
      //                   pactEndDate: '2024-12-31',
      //                   departmentName: '신경외과(뇌신경센터)',
      //                   doctorName: '김의사',
      //                   diagnosisName: '주 진단명 (뇌종양 수술)',
      //                   spcTestDescription: '검체검사 외 3건',
      //                   imgTestDescription: '영상검사 외 3건',
      //                   funcTestDescription: '기능검사 외 3건',
      //                   patTestDescription: '병리검사 외 3건',
      //                 },
      //                 {
      //                   pactId: '5',
      //                   pactType: 'I',
      //                   pactStartDate: '2024-01-01',
      //                   pactEndDate: '2024-12-31',
      //                   departmentName: '신경외과(뇌신경센터)',
      //                   doctorName: '김의사',
      //                   diagnosisName: '주 진단명 (뇌종양 수술)',
      //                   spcTestDescription: '검체검사 외 3건',
      //                   imgTestDescription: '영상검사 외 3건',
      //                   funcTestDescription: '기능검사 외 3건',
      //                   patTestDescription: '병리검사 외 3건',
      //                 },
      //                 {
      //                   pactId: '5',
      //                   pactType: 'I',
      //                   pactStartDate: '2024-01-01',
      //                   pactEndDate: '2024-12-31',
      //                   departmentName: '신경외과(뇌신경센터)',
      //                   doctorName: '김의사',
      //                   diagnosisName: '주 진단명 (뇌종양 수술)',
      //                   spcTestDescription: '검체검사 외 3건',
      //                   imgTestDescription: '영상검사 외 3건',
      //                   funcTestDescription: '기능검사 외 3건',
      //                   patTestDescription: '병리검사 외 3건',
      //                 },
      //                 {
      //                   pactId: '5',
      //                   pactType: 'I',
      //                   pactStartDate: '2024-01-01',
      //                   pactEndDate: '2024-12-31',
      //                   departmentName: '신경외과(뇌신경센터)',
      //                   doctorName: '김의사',
      //                   diagnosisName: '주 진단명 (뇌종양 수술)',
      //                   spcTestDescription: '검체검사 외 3건',
      //                   imgTestDescription: '영상검사 외 3건',
      //                   funcTestDescription: '기능검사 외 3건',
      //                   patTestDescription: '병리검사 외 3건',
      //                 },
      //                 {
      //                   pactId: '5',
      //                   pactType: 'I',
      //                   pactStartDate: '2024-01-01',
      //                   pactEndDate: '2024-12-31',
      //                   departmentName: '신경외과(뇌신경센터)',
      //                   doctorName: '김의사',
      //                   diagnosisName: '주 진단명 (뇌종양 수술)',
      //                   spcTestDescription: '검체검사 외 3건',
      //                   imgTestDescription: '영상검사 외 3건',
      //                   funcTestDescription: '기능검사 외 3건',
      //                   patTestDescription: '병리검사 외 3건',
      //                 },
      //               ]
      //             : []),
      //         ],
      //       },
      //     });
      //   }, 300);
      // });
      return axios.get(
        `${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/v1/karenote/timeline?hspId=${hspId}&patientNumber=${patientNumber}&searchStartDate=${searchStartDate}&searchEndDate=${searchEndDate}`,
      );
    },
    placeholderData: (prev) => prev,
    gcTime: 0,
  });

  return { ...data, refetch, isFetching };
};

// I-32
export const useGetDiagnoses = ({ hspId, pactId, enabled = true }) => {
  const { data } = useQuery({
    queryKey: ['diagnose', hspId, pactId],
    queryFn: () => {
      // return {
      //   status: 200,
      //   data: {
      //     result: 0,
      //     diagnosisName: '진단명, 수술명, 증상명',
      //     diagnosisCode: '주 진단코드',
      //     diagnosisDate: '2025-12-12',
      //   },
      // };
      return axios.get(
        `${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/v1/karenote/pacts/${pactId}/diagnoses?hspId=${hspId}`,
      );
    },
    enabled,
    gcTime: 0,
  });

  return data;
};

// I-33
export const useGetPactTest = ({ hspId, pactId, patientNumber }) => {
  const { data } = useQuery({
    queryKey: ['pactTest', pactId],
    queryFn: () => {
      // return {
      //   status: 200,
      //   data: {
      //     result: 0,
      //     tests: [
      //       {
      //         pactId: '수진 번호',
      //         testType: 'SPC',
      //         testId: '1',
      //         testName: '검사명',
      //         abnormalFlag: 'N',
      //         testDate: '2025-05-12',
      //         resultDate: '2025-05-12',
      //       },
      //       {
      //         pactId: '수진 번호',
      //         testType: 'IMG',
      //         testId: '2',
      //         testName: '검사명',
      //         abnormalFlag: 'Y',
      //         testDate: '2025-05-12',
      //         resultDate: '2025-05-12',
      //       },
      //       {
      //         pactId: '수진 번호',
      //         testType: 'FUNC',
      //         testId: '3',
      //         testName: '검사명',
      //         abnormalFlag: 'N',
      //         testDate: '2025-05-12',
      //         resultDate: '2025-05-12',
      //       },
      //     ],
      //   },
      // };
      return axios.get(
        `${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/v1/karenote/pacts/${pactId}/tests?patientNumber=${patientNumber}&hspId=${hspId}`,
      );
    },
    placeholderData: (prev) =>
      prev
        ? prev
        : {
            data: null,
          },
    gcTime: 0,
  });

  return data;
};

// I-34
export const useGetSpecimens = ({ testId, hspId }) => {
  const { data } = useSuspenseQuery({
    queryKey: ['specimens', testId, hspId],
    queryFn: () => {
      // return {
      //   status: 200,
      //   data: {
      //     result: 0,
      //     specimenResults: [
      //       {
      //         specimenCode: '1',
      //         specimenEnName: 'Calcium',
      //         specimenKrName: '칼슘',
      //         testResult: 90,
      //         testResultUnit: 'mg/dL',
      //         referenceMinValue: 50,
      //         referenceMaxValue: 80,
      //       },
      //       {
      //         specimenCode: '2',
      //         specimenEnName: 'Glucose',
      //         specimenKrName: '포도당',
      //         testResult: 176,
      //         testResultUnit: 'mg/dL',
      //         referenceMinValue: '',
      //         referenceMaxValue: '',
      //       },
      //       {
      //         specimenCode: '3',
      //         specimenEnName: '인',
      //         specimenKrName: 'Phosphorus',
      //         testResult: 3.2,
      //         testResultUnit: 'mg/dL',
      //         referenceMinValue: 50,
      //         referenceMaxValue: '',
      //       },
      //     ],
      //   },
      // };
      return axios.get(
        `${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/v1/karenote/tests/${testId}/specimens?hspId=${hspId}`,
      );
    },
    gcTime: 0,
  });

  return data;
};

// I-35
export const useGetSpecimenDetail = ({ patientNumber, specimenCode, hspId, searchStartDate, searchEndDate }) => {
  const { data } = useQuery({
    queryKey: ['specimens', specimenCode, searchStartDate, searchEndDate],
    queryFn: () => {
      // return {
      //   status: 200,
      //   data: {
      //     result: '0',
      //     testResultUnit: 'mg/dL',
      //     referenceMinValue: '0.5',
      //     referenceMaxValue: '0.9',
      //     tests: [
      //       {
      //         testDate: '2025-12-01',
      //         testResult: '0.80',
      //       },
      //     ],
      //   },
      // };
      return axios
        .get(
          `${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/v1/karenote/patients/${patientNumber}/specimens/${specimenCode}?hspId=${hspId}&searchStartDate=${searchStartDate}&searchEndDate=${searchEndDate}`,
        )
        .then((res) => {
          res.data.tests.reverse();
          return res;
        });
    },
    placeholderData: (prev) =>
      prev
        ? prev
        : {
            data: null,
          },
    gcTime: 0,
  });

  return data;
};

